import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

// const baseUrl = 'http://192.168.1.8:3000';
const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  situacoesProjeto: [],
  situacoesAtividade: [],
  situacoes: [],
  situacoesSelected: [],
};

const getters = {
  // Situação
  situacoesProjeto: state => state.situacoesProjeto.filter(s => s.Status.startsWith('A')).sort((a,b) => a.Descricao > b.Descricao ? 1 : -1),
  situacoesAtividade: state => state.situacoesAtividade.filter(s => s.Status.startsWith('A')).sort((a,b) => a.Descricao > b.Descricao ? 1 : -1),
  situacoes: state => state.situacoes.sort((a,b) => a.Descricao > b.Descricao ? 1 : -1),
  situacoesSelected: state => state.situacoesSelected.sort((a,b) => a.Descricao > b.Descricao ? 1 : -1),
}

const actions = {
  // Situação
  async fetchSituacoesProjeto({ commit }) {
    const response = await axios.get(`${baseUrl}/situacoes?idTipoSituacao=10`);
    if (response.data) {
      commit('setSituacoesProjeto', response.data);
    } else {
      commit('setSituacoesProjeto', []);
    }
  },
  async fetchSituacoesAtividade({ commit }) {
    const response = await axios.get(`${baseUrl}/situacoes?idTipoSituacao=7`);
    if (response.data) {
      commit('setSituacoesAtividade', response.data);
    } else {
      commit('setSituacoesAtividade', []);
    }
  },
  async fetchSituacoesSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/situacoes?idLayoutSql=${args.idLayoutSql}`);
      if (response.data.length) {
        commit('setSituacoes', response.data);
      } else {
        commit('setSituacoes', []);
      }
    } catch (error) {
      commit('setSituacoes', []);
    }
  },
  async addSituacao({ commit }, situacao) {
    const response = await axios.post(`${baseUrl}/situacoes`, situacao, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    situacao.IdSituacao = response.data.IdSituacao;
    commit('newSituacao', situacao);
    return response.data.IdSituacao;
  },
  async updateSituacao({ commit }, updSituacao) {
    await axios.put(`${baseUrl}/situacoes`, updSituacao, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('updateSituacao', updSituacao);
  },
  async deleteSituacao({ commit }, id) {
    await axios.delete(`${baseUrl}/situacoes/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeSituacao', id);
  },
  async selectSituacoes({ commit }, situacoes) {
    commit('newSituacaoSelected', situacoes);
  },
  async resetSituacoesSelected({ commit }) {
    commit('resetSituacoesSelected');
  },
}

const mutations = {
  // Situação
  setSituacoesProjeto: (state, situacoes) => state.situacoesProjeto = situacoes,
  setSituacoesAtividade: (state, situacoes) => state.situacoesAtividade = situacoes,
  setSituacoes: (state, situacoes) => state.situacoes = situacoes,
  newSituacao: (state, situacao) => state.situacoes.push(situacao),
  removeSituacao: (state, id) => state.situacoes = state.situacoes.filter(situacao => situacao.IdSituacao !== id),
  updateSituacao: (state, updSituacao) => {
    const index = state.situacoes.findIndex(situacao => situacao.IdSituacao === updSituacao.IdSituacao);
    if (index !== -1) {
      state.situacoes.splice(index, 1, updSituacao);
    }
  },
  newSituacaoSelected: (state, situacoes) => state.situacoesSelected = situacoes,
  resetSituacoesSelected: state => state.situacoesSelected = [],
}

export default {
  state,
  getters,
  actions,
  mutations
}